import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import { BankUserInputDto, BankUserPreviewDto, BankUserSearchResultDto } from "../interfaces/admin/BankUser";

const apiEndpoint = "/bankUser";

const getBankUsersAsync = async (query: string): Promise<AxiosResponse<Array<BankUserSearchResultDto>>> => {
  return await http.get<Array<BankUserSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getBankUsersCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getBankUserAsync = async (id: number): Promise<AxiosResponse<BankUserPreviewDto>> => {
  return await http.get<BankUserPreviewDto>(`${apiEndpoint}/${id}`);
};

const addBankUserAsync = async (model: BankUserInputDto): Promise<AxiosResponse<BankUserInputDto>> => {
  return await http.post<BankUserInputDto>(apiEndpoint, model);
};

const updateBankUserAsync = async (model: BankUserInputDto): Promise<AxiosResponse<BankUserInputDto>> => {
  return await http.put<BankUserInputDto>(`${apiEndpoint}/${model.bankUserId}`, model);
};

export default {
  getBankUsersAsync,
  getBankUsersCountAsync,
  getBankUserAsync,
  addBankUserAsync,
  updateBankUserAsync,
};
